import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const CustomDesignPage = lazy(() => import('../pages/custom-design/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CategoryPage = lazy(() => import('../pages/category/page'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/hakkimizda', element: <AboutPage /> },
  { path: '/urunler', element: <ProductsPage /> },
  { path: '/projeler', element: <ProjectsPage /> },
  { path: '/ozel-tasarim', element: <CustomDesignPage /> },
  { path: '/iletisim', element: <ContactPage /> },
  { path: '/kategori/:slug', element: <CategoryPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;